import { useEffect } from 'react'

const useFidelityActionRealtimeSync = (contactId, isEligibleAgent, onCompleted) => {
  useEffect(() => {
    if (!contactId || !isEligibleAgent) {
      return undefined
    }

    const channelName = `fidelity-maximizer-action.${contactId}`

    window.Echo.channel(channelName)
      .listen('.operation.success', event =>
        onCompleted({ success: true, message: event?.data?.message, data: event?.data?.data }),
      )
      .listen('.operation.failed', event => onCompleted({ success: false, message: event?.error }))

    return () => {
      window.Echo.leaveChannel(channelName)
    }
  }, [contactId, isEligibleAgent, onCompleted])
}

export default useFidelityActionRealtimeSync
